import React from 'react';
import { useTranslation } from 'react-i18next';
import { BusinessPageCardsTypes } from '../BusinessPage.types';
import * as S from './BusinessPageCards.styles';
import NoSsr from '@/components/NoSsr/NoSsr';

export const BusinessPageCardsItems: React.FC<BusinessPageCardsTypes> = ({
  item,
}) => {
  const { t } = useTranslation();

  const cardTitle =
    item === 'support' || item === 'service' ? '' : t(`business.${item}`);

  return (
    <NoSsr>
      <S.BusinessPageCardsItems $image={item}>
        <S.BusinessPageCardsItemsText>
          {cardTitle}
          <S.BusinessPageCardsItemsDescription>
            {t(`business.description.${item}`)}
          </S.BusinessPageCardsItemsDescription>
        </S.BusinessPageCardsItemsText>
      </S.BusinessPageCardsItems>
    </NoSsr>
  );
};

BusinessPageCardsItems.displayName = 'BusinessPageCardsItems';
